import { render, staticRenderFns } from "./VehicleTypeDetailsContainer.vue?vue&type=template&id=0d96d722"
import script from "./VehicleTypeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./VehicleTypeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports